import { h } from "@stencil/core";
const baseClass = "ux-guided-tour-progress";
export const GuidedTourProgress = ({ step = 0, total = 0 }) => {
    const complete = total > 0 ? Math.min(1, step / total) : -1;
    return complete < 0 ? null : (h("div", { class: baseClass }, h("div", { class: `${baseClass}__bar`, style: {
            width: `${complete * 100}%`
        } })));
};
//# sourceMappingURL=guided-tour-progress.js.map
